"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _MandantInfoService = _interopRequireDefault(require("./version/base/service/MandantInfoService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ApiConnectorSingleton = function () {
  var instance;
  return {
    getInstance: function getInstance(url, version, kundennummer, trainingCenter, modules) {
      if (!instance) {
        instance = new ApiConnector(url, version, kundennummer, trainingCenter, modules);
      }

      return instance;
    }
  };
}();

var ApiConnector =
/*#__PURE__*/
function () {
  function ApiConnector(url, version, mandant, trainingCenter, modules) {
    var _this = this;

    _classCallCheck(this, ApiConnector);

    if (version !== undefined && mandant !== undefined) {
      this.version = version;
      this.url = url + "/academies/api";
      this.kundennummer = mandant;
      this.trainingCenterId = trainingCenter;
      this.modules = modules;
    } else {
      var domain = window.location.hostname;
      new _MandantInfoService["default"](url).getMandantInfoForHost(domain).then(function (mandantInfo) {
        _this.version = mandantInfo.apiVersion;
        _this.url = url + "/academies/api";
        _this.kundennummer = mandantInfo.mandantName;
        _this.trainingCenterId = mandantInfo.trainingcenterId;
        _this.modules = modules;
      });
    }
  }

  _createClass(ApiConnector, [{
    key: "getAuthService",
    value: function getAuthService() {
      return this.getService('AuthenticationService');
    }
  }, {
    key: "getUserService",
    value: function getUserService() {
      return this.getService('UserService');
    }
  }, {
    key: "getRegistrationService",
    value: function getRegistrationService() {
      return this.getService('RegistrationService');
    }
  }, {
    key: "getContactService",
    value: function getContactService() {
      return this.getService('ContactService');
    }
  }, {
    key: "getCategoryService",
    value: function getCategoryService() {
      return this.getService('CategoryService');
    }
  }, {
    key: "getBookingService",
    value: function getBookingService() {
      return this.getService('BookingService');
    }
  }, {
    key: "getWebinarService",
    value: function getWebinarService() {
      return this.getService('WebinarService');
    }
  }, {
    key: "getMeetingService",
    value: function getMeetingService() {
      return this.getService('MeetingService');
    }
  }, {
    key: "getCourseService",
    value: function getCourseService() {
      return this.getService('CourseService');
    }
  }, {
    key: "getRequestWorkflowService",
    value: function getRequestWorkflowService() {
      return this.getService('RequestWorkflowService');
    }
  }, {
    key: "getDataProtectionService",
    value: function getDataProtectionService() {
      return this.getService('DataProtectionService');
    }
  }, {
    key: "getSecurityQuestionService",
    value: function getSecurityQuestionService() {
      return this.getService('SecurityQuestionService');
    }
  }, {
    key: "getSettingsService",
    value: function getSettingsService() {
      return this.getService('SettingsService');
    }
  }, {
    key: "getNewsService",
    value: function getNewsService() {
      return this.getService('NewsService');
    }
  }, {
    key: "getFAQService",
    value: function getFAQService() {
      return this.getService('FAQService');
    }
  }, {
    key: "getGamificationService",
    value: function getGamificationService() {
      return this.getService('GamificationService');
    }
  }, {
    key: "getBonusPointsService",
    value: function getBonusPointsService() {
      return this.getService('BonusPointsService');
    }
  }, {
    key: "getPasswordRequirementsService",
    value: function getPasswordRequirementsService() {
      return this.getService('PasswordRequirementsService');
    }
  }, {
    key: "getMTKService",
    value: function getMTKService() {
      return this.getService('MTKService');
    }
  }, {
    key: "getProjectService",
    value: function getProjectService() {
      return this.getService('ProjectService');
    }
  }, {
    key: "getLicenseKeyService",
    value: function getLicenseKeyService() {
      return this.getService('LicenseKeyService');
    }
  }, {
    key: "getTagService",
    value: function getTagService() {
      return this.getService('TagService');
    }
  }, {
    key: "getService",
    value: function getService(serviceName) {
      try {
        return new (require('./version/v' + this.version + '/service/' + serviceName)["default"])(this.url, this.kundennummer, this.obtainTokenMethod, this.removeTokenMethod, this.tokenMethod, this.trainingCenterId, this.modules);
      } catch (e) {
        return new (require('./version/base/service/' + serviceName)["default"])(this.url, this.kundennummer, this.obtainTokenMethod, this.removeTokenMethod, this.tokenMethod, this.trainingCenterId, this.modules);
      }
    }
  }, {
    key: "setObtainToken",
    value: function setObtainToken(obtainTokenMethod) {
      this.obtainTokenMethod = obtainTokenMethod;
    }
  }, {
    key: "setRemoveToken",
    value: function setRemoveToken(removeTokenMethod) {
      this.removeTokenMethod = removeTokenMethod;
    }
  }, {
    key: "setToken",
    value: function setToken(tokenMethod) {
      this.tokenMethod = tokenMethod;
    }
  }]);

  return ApiConnector;
}();

var _default = ApiConnectorSingleton;
exports["default"] = _default;